export function getIsActivePath(pathname: string, to: string) {
  const normalize = (path: string) => path.replace(/\/+$/, "") || "/";

  const normalizedPathname = normalize(pathname);
  const normalizedTo = normalize(to);

  // Ensure exact match or valid subpath with trailing slash
  return normalizedPathname === normalizedTo || normalizedPathname.startsWith(`${normalizedTo}/`);
}
